(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["YJR-IMAGENES"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-yjr-video-wrap]').forEach(function (wrap) {
    var v = wrap.querySelector('video');
    if (!v) return;
    v.muted = true;

    function reveal() { wrap.classList.add('is-loaded'); }

    function checkFull() {
      try {
        if (v.buffered.length && v.duration && v.buffered.end(v.buffered.length - 1) >= v.duration - 0.25) {
          reveal();
        }
      } catch (e) {}
    }

    // Listo cuando puede reproducirse sin cortes (suficiente buffer = se ve nítido)
    if (v.readyState >= 4) { reveal(); }
    v.addEventListener('canplaythrough', reveal);
    v.addEventListener('progress', checkFull);
    v.addEventListener('loadeddata', checkFull);

    var p = v.play();
    if (p && p.catch) { p.catch(function () {}); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["YJR-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-yjr-header]');
    if (!header) return;

    // Abrir / cerrar el menú móvil (pantalla completa)
    var drawer = header.querySelector('[data-yjr-drawer]');
    var burger = header.querySelector('[data-yjr-burger]');

    function closeSubPanels() {
      if (!drawer) return;
      drawer.classList.remove('is-sub-open');
      drawer.querySelectorAll('.yjr-drawer__panel--sub.is-active').forEach(function (p) {
        p.classList.remove('is-active');
      });
    }
    function closeDrawer() {
      header.classList.remove('is-open');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      closeSubPanels();
    }

    if (burger) {
      burger.addEventListener('click', function () {
        var open = header.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.style.overflow = open ? 'hidden' : '';
        if (!open) closeSubPanels();
      });
    }

    var closeBtn = header.querySelector('[data-yjr-drawer-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    // Abrir un segundo nivel: entra desde la derecha
    header.querySelectorAll('[data-yjr-open-sub]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!drawer) return;
        var id = btn.getAttribute('data-yjr-open-sub');
        var panel = drawer.querySelector('.yjr-drawer__panel--sub[data-yjr-sub="' + id + '"]');
        if (!panel) return;
        panel.classList.add('is-active');
        drawer.classList.add('is-sub-open');
        panel.scrollTop = 0;
      });
    });

    // Volver al nivel anterior
    header.querySelectorAll('[data-yjr-back]').forEach(function (btn) {
      btn.addEventListener('click', closeSubPanels);
    });

    // Cerrar con Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && header.classList.contains('is-open')) closeDrawer();
    });

    // Mega menú escritorio: abrir al entrar, cerrar con retardo (intención de hover)
    var closeDelay = parseInt(header.getAttribute('data-close-delay') || '250', 10);
    var navItems = header.querySelectorAll('.yjr-header__inner--desktop .yjr-nav__item');
    // Desenfocar el contenido de la página (todo el body menos el header) al abrir el menú
    var blurPx = parseInt(header.getAttribute('data-menu-blur') || '0', 10);
    var headerRoot = header;
    while (headerRoot.parentElement && headerRoot.parentElement !== document.body) { headerRoot = headerRoot.parentElement; }
    function setPageBlur(on) {
      if (!blurPx) return;
      var targets = [];
      Array.prototype.slice.call(document.body.children).forEach(function (el) {
        if (el === headerRoot) return;
        var tag = el.tagName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'LINK' || tag === 'NOSCRIPT') return;
        targets.push(el);
      });
      if (!targets.length) {
        ['main', 'footer'].forEach(function (sel) {
          document.querySelectorAll(sel).forEach(function (el) { if (!el.contains(header)) targets.push(el); });
        });
      }
      targets.forEach(function (el) {
        el.style.transition = 'filter .3s ease';
        el.style.filter = on ? 'blur(' + blurPx + 'px)' : '';
      });
    }
    function syncMenuOpen() {
      var anyOpen = window.innerWidth > 768 && !!header.querySelector('.yjr-nav__item.is-open');
      setPageBlur(anyOpen);
      updateSolid();
    }
    var navHover = false;
    function updateSolid() {
      var anyOpen = !!header.querySelector('.yjr-nav__item.is-open');
      var solid = window.innerWidth > 768 && (anyOpen || navHover);
      if (headerRoot && headerRoot.classList) { headerRoot.classList.toggle('is-menu-open', solid); }
    }
    // Hover sobre el menu de escritorio -> header solido (aunque el link no tenga submenu).
    // El mega-menu es descendiente de .yjr-nav, asi que sigue solido mientras estes dentro de el.
    var desktopNav = header.querySelector('.yjr-header__inner--desktop .yjr-nav');
    if (desktopNav) {
      var navTimer;
      desktopNav.addEventListener('mouseenter', function () { clearTimeout(navTimer); navHover = true; updateSolid(); });
      desktopNav.addEventListener('mouseleave', function () {
        clearTimeout(navTimer);
        navTimer = setTimeout(function () { navHover = false; updateSolid(); }, closeDelay);
      });
    }
    navItems.forEach(function (item) {
      var dd = item.querySelector('.yjr-dropdown');
      if (!dd) return;
      var timer;
      item.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        item.classList.add('is-open');
        syncMenuOpen();
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { item.classList.remove('is-open'); syncMenuOpen(); }, closeDelay);
      });
    });

    // Alinear el contenido del mega menú con el espacio del menú (panel full width)
    function alignDropdowns() {
      var navEl = header.querySelector('.yjr-header__inner--desktop .yjr-nav');
      if (!navEl) return;
      var r = navEl.getBoundingClientRect();
      header.style.setProperty('--yjr-dd-left', Math.max(0, r.left) + 'px');
      header.style.setProperty('--yjr-dd-right', Math.max(0, window.innerWidth - r.right) + 'px');
    }
    alignDropdowns();
    window.addEventListener('load', alignDropdowns);
    window.addEventListener('resize', alignDropdowns);
    setTimeout(alignDropdowns, 300);
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(alignDropdowns); }

    // Cerrar al pasar a escritorio
    window.addEventListener('resize', function () {
      if (window.innerWidth > 768 && header.classList.contains('is-open')) {
        header.classList.remove('is-open');
        document.body.style.overflow = '';
        if (burger) burger.setAttribute('aria-expanded', 'false');
        closeSubPanels();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
